export default "__VITE_ASSET__DbtVlDwq__"